<template lang="pug">
  grid(
    name='Programs & Events',
    desc='Create and manage your programs and events'
    search=true
    resizing=false
    :endpoint='api.$.program.list'
  )
</template>

<script>

import Grid from '@/components/Grid'
import model from './model'

export default {
  components: {
    Grid
  },
  data() {
    return { model }
  }
}

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// index.vue?29f932a9